<template>
  <div class="contentbox">
    <div class="content-title">
      <div class="content-titlebox">
        <transition-group tag="div" name="titel">
          <span
            v-for="(text,textIndex) in title"
            :key="text+textIndex"
            v-show="titleShow"
            :style="{'animation-delay': 0.1*(title.length-textIndex)+'s'}"
          >{{text}}</span>
        </transition-group>
      </div>
      <div class="content-timebox">
        <p id="content-time">{{time}}</p>
      </div>
    </div>
    <div class="content-charts">
      <div class="content_charts_left">
        <div class="left_top_textList charts_box">
          <div class="charts_title">
            <p>今日数据</p>
          </div>
          <div class="charts_data has_charts_title">
            <div class="charts_table">
              <div class="charts_today_count charts_today_count_left">
                <span>已受理</span>
                <span>{{serviceCount.DayAcceptCount}}</span>
              </div>
              <!-- <div id="canvasLiquid" class="charts_canvas" ref="canvasLiquid"></div> -->
            </div>
            <div class="charts_table">
              <div class="charts_today_count charts_today_count_right">
                <span>已办理</span>
                <span>{{serviceCount.DayFinishCount}}</span>
              </div>
              <!-- <div class="charts_canvas" id="canvasMeterGauge" ref="canvasMeterGauge"></div> -->
            </div>
          </div>
          <!-- <div class="textList_div">
            <p>
              2020年&nbsp;累计受理量：
              <span>4254</span>件
            </p>
          </div>
          <div class="textList_div">
            <p>
              累计办结
              <span>4254</span>件&nbsp;
              办结率为
              <span>99.4</span>%
            </p>
          </div>
          <div class="textList_div">
            <p>
              受理最多部门：工商局
              &nbsp;
              <span>99.4</span>%
            </p>
          </div>
          <div class="textList_div">
            <p>
              满意度最高部门：农业局
              &nbsp;
              <span>99.4</span>%
            </p>
          </div>-->
        </div>
        <div class="left_mid_today charts_box">
          <div class="charts_title">
            <p>本周数量统计</p>
          </div>
          <div class="charts_data has_charts_title">
            <div class="charts_table">
              <div id="canvasLine" ref="canvasLine" class="charts_canvas"></div>
            </div>
          </div>
        </div>
        <div class="left_bottom_lineNum charts_box">
          <div class="charts_title">
            <p>2020年累计数量</p>
          </div>
          <div class="charts_data has_charts_title">
            <div class="charts_table">
              <div id="canvasLiquid" class="charts_canvas" ref="canvasLiquid"></div>
            </div>
            <div class="charts_table">
              <div class="charts_canvas" id="canvasMeterGauge" ref="canvasMeterGauge"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_charts_mid">
        <div class="mid_top_map charts_box">
          <div class="map_infos_add">
            <p>新乡市职权清单：{{this.dayModel.TotalCount}}</p>
            <p>纳入行政服务中心的职权清单：{{this.dayModel.ChannelTotalCount}}</p>
            <p
              v-for="(area, areaIndex) in areaList"
              :key="areaIndex"
              v-show="area.Name == '高新区' || area.Name == '经开区' || area.Name == '平原示范区'"
            >{{area.Name}}职权清单：{{area.TotalCount}}</p>
          </div>
          <div id="container"></div>
        </div>
        <div class="mid_bottom_chart charts_box">
          <div class="charts_data">
            <div class="charts_table">
              <div class="charts_canvas" id="canvasColumn" ref="canvasColumn"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_charts_right">
        <div class="right_top_pie charts_box">
          <!-- <div class="charts_title">
            <p>今日数据</p>
          </div>-->
          <div class="charts_data">
            <div class="charts_table">
              <div class="charts_canvas" id="canvasPie" ref="canvasPie"></div>
            </div>
          </div>
        </div>
        <div class="right_bottom_list charts_box">
          <div class="charts_title">
            <p>各部门行政许可类数量</p>
          </div>
          <div class="charts_data has_charts_title">
            <div class="charts_table">
              <div class="tbl_header">
                <table
                  class="analysis_context_text_table"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                >
                  <colgroup>
                    <col name="table1" width="50%"></col>
                    <col name="table2" width="25%"></col>
                    <col name="table3" width="25%"></col>
                  </colgroup>
                  <thead>
                    <tr>
                      <td>部门数量</td>
                      <td>清单数量</td>
                      <td>占比</td>
                    </tr>
                  </thead>
                  <tbody style="opacity: 0;"></tbody>
                </table>
              </div>
              <div class="tbl_hidden">
                <div class="tbl_body" id="table_body" :style="{top:count+'px'}">
                  <table
                    class="analysis_context_text_table"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                  <colgroup>
                    <col name="table1" width="50%"></col>
                    <col name="table2" width="25%"></col>
                    <col name="table3" width="25%"></col>
                  </colgroup>
                    <thead style="opacity: 0">
                      <tr>
                        <td>部门数量</td>
                        <td>清单数量</td>
                        <td>占比</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(depart, index) in deptList" :key="index">
                        <td>{{depart.Name}}</td>
                        <td>{{depart.DeptCount}}</td>
                        <td>{{depart.percentlv}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapLoader from "@/utils/map.js";
import { Line, Pie, Liquid, MeterGauge, Column } from "@antv/g2plot";
import { Chart, registerShape } from "@antv/g2";
import { DataView } from "@antv/data-set";
export default {
  data() {
    return {
      time: "",
      menuNum: -1,
      title: "新乡市政府部门权责清单数据展示",
      titleShow: true,
      map: {},
      colors: {},
      DistrictLayer: {},
      citysText: [
        // {
        //   name: "新乡市",
        //   lng: 113.92679,
        //   lat: 35.303589
        // },
        {
          name: "卫滨区",
          lng: 113.86578,
          lat: 35.302117
        },
        {
          name: "红旗区",
          lng: 113.942617,
          lat: 35.290763
        },
        {
          name: "牧野区",
          lng: 113.918842,
          lat: 35.338599
        },
        {
          name: "凤泉区",
          lng: 113.915184,
          lat: 35.383978
        },
        {
          name: "新乡县",
          lng: 113.81389,
          lat: 35.170381
        },
        {
          name: "辉县市",
          lng: 113.80572,
          lat: 35.462964
        },
        {
          name: "卫辉市",
          lng: 114.0647,
          lat: 35.398389
        },
        {
          name: "延津县",
          lng: 114.205624,
          lat: 35.165876
        },
        {
          name: "获嘉县",
          lng: 113.657915,
          lat: 35.259628
        },
        {
          name: "原阳县",
          lng: 113.939829,
          lat: 35.066873
        },
        {
          name: "封丘县",
          lng: 114.418883,
          lat: 35.041198
        },
        {
          name: "长垣市",
          lng: 114.668936,
          lat: 35.201547
        }
      ],
      serviceCount: {},
      weekList: [],
      areaList: [],
      dayModel: {},
      typeList: [],
      deptList: [],
      count: 0
    };
  },
  methods: {
    initTime() {
      setInterval(() => {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        this.time = `${year}年${month < 10 ? "0" + month : month}月${day}日
                            ${hours < 10 ? "0" + hours : hours}:${
          minutes < 10 ? "0" + minutes : minutes
        }:${seconds < 10 ? "0" + seconds : seconds}`;
      }, 1000);
    },
    initInterval() {
      setInterval(() => {
        this.titleShow = !this.titleShow;
      }, 5000);
    },
    initMap() {
      //异步加载地图
      MapLoader().then(
        AMap => {
          this.map = new AMap.Map("container", {
            center: [113.92679, 35.303589],
            zoom: 9,
            mapStyle: "amap://styles/85886b4a318d11fd612e93958b528108"
          });
          AMap.plugin("AMap.DistrictLayer", function() {
            //异步加载插件
            this.DistrictLayer = new AMap.DistrictLayer();
            this.map.addControl(this.DistrictLayer);
          });
          this.initCityMap(AMap);
          this.initCityText(AMap);
        },
        e => {
          console.log("地图加载失败", e);
        }
      );
    },
    //行政区域图层
    initCityMap(AMap) {
      let thisColor = this;
      let disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,
        adcode: ["410700"],
        depth: 2,
        styles: {
          fill: function(properties) {
            var adcode = properties.adcode;
            return thisColor.getColorByAdcode(adcode);
          },
          "province-stroke": "cornflowerblue",
          "city-stroke": "white", //中国地级市边界
          "county-stroke": "rgba(255,255,255,0.5)" //中国区县边界
        }
      });
      disProvince.setMap(this.map);
    },
    //随机颜色
    getColorByAdcode(adcode) {
      if (!this.colors[adcode]) {
        let gb = Math.random() * 155 + 50;
        this.colors[adcode] = "rgb(" + gb + "," + gb + ",255)";
        // let num = 3;
        // let color = [];
        // while (num--) {
        //   color.push(Math.floor(Math.random() * 254 + 1));
        // }
        // this.colors[adcode] = "rgb(" + color.join(",") + ")";
      }
      return this.colors[adcode];
    },
    //纯文本标注
    initCityText(AMap) {
      for (let city of this.citysText) {
        let areas = this.areaList.find(area => {
          return area.Name == city.name;
        });
        if (areas.TotalCount >= 0) {
          let text = new AMap.Text({
            text: city.name + "\n" + areas.TotalCount,
            position: new AMap.LngLat(city.lng, city.lat),
            map: this.map
          });
          text.setStyle({
            "background-color": "transparent",
            border: 0,
            color: "#f39c12",
            "font-weight": "bold"
          });
        }
        // text.setMap(this.map);
      }
    },
    initCanvasLine() {
      let height = this.$refs.canvasLine.clientHeight;
      let width = this.$refs.canvasLine.clientWidth;
      const data = [
        { year: "星期一", value: 180, type: "已受理" },
        { year: "星期二", value: 150, type: "已受理" },
        { year: "星期三", value: 80, type: "已受理" },
        { year: "星期四", value: 160, type: "已受理" },
        { year: "星期五", value: 120, type: "已受理" },
        { year: "星期一", value: 140, type: "已完结" },
        { year: "星期二", value: 120, type: "已完结" },
        { year: "星期三", value: 80, type: "已完结" },
        { year: "星期四", value: 110, type: "已完结" },
        { year: "星期五", value: 10, type: "已完结" }
      ];
      // const chart = new Chart({
      //   container: "canvasLine",
      //   autoFit: false,
      //   width: width,
      //   height: height,
      //   padding: "auto"
      // });

      // chart.data(data);
      // chart.scale({
      //   year: {
      //     range: [0.05, 0.95]
      //   },
      //   value: {
      //     nice: true
      //   }
      // });

      // chart.tooltip({
      //   showCrosshairs: true,
      //   shared: true
      // });
      // chart.axis("year", {
      //   label: {
      //     style: {
      //       fill: "#82ccdd"
      //     }
      //   },
      //   line: {
      //     style: {
      //       stroke: "#82ccdd"
      //     }
      //   },
      //   tickLine: {
      //     style: {
      //       fill: "#82ccdd"
      //     }
      //   }
      // });
      // chart.axis("value", {
      //   label: {
      //     formatter: val => {
      //       return val + "件";
      //     },
      //     style: {
      //       fill: "#82ccdd"
      //     }
      //   },
      //   grid: null
      // });
      // chart.legend("type", {
      //   itemName: {
      //     style: {
      //       fill: "#82ccdd"
      //     }
      //   }
      // });
      // chart
      //   .line()
      //   .position("year*value")
      //   .color("type", ["#e74c3c", "#2ecc71"])
      //   .shape("smooth");

      // chart
      //   .point()
      //   .position("year*value")
      //   .color("type", ["#e74c3c", "#2ecc71"])
      //   .shape("circle")
      //   .label("value");

      // chart.render();
      const linePlot = new Line("canvasLine", {
        height: height,
        width: width,
        // title: {
        //   visible: true,
        //   text: "本周受理数据",
        //   style: {
        //     fill: "#82ccdd"
        //   }
        // },
        padding: "auto",
        data,
        meta: {
          year: {
            alias: "年份",
            range: [0, 1]
          },
          value: {
            alias: "数量",
            formatter: v => {
              return `${v}件`;
            }
          }
        },
        xField: "year",
        yField: "value",
        color: ["#FE740C", "#55E6C1"],
        point: {
          visible: true,
          size: 5,
          color: "#82ccdd",
          style: {
            stroke: "#FE740C",
            lineWidth: 2,
            fillOpacity: 0.6
          }
        },
        yAxis: {
          formatter: v => {
            return v + "k";
          },
          label: {
            style: {
              fill: "#82ccdd"
            }
          },
          grid: {
            visible: false
          }
        },
        xAxis: {
          label: {
            visible: true,
            autoHide: false,
            style: {
              fill: "#82ccdd"
            }
          },
          line: {
            visible: false
          },
          tickLine: {
            visible: false
          },
          type: "dateTime"
        },
        smooth: true,
        label: {
          visible: true,
          type: "line"
          // style: {
          //   fill: "#82ccdd",
          //   stroke: "#82ccdd",
          //   lineWidth: 2
          // }
        },
        legend: {
          visible: false
          // position: "right-top",
          // label: {
          //   style: {
          //     fill: "#82ccdd"
          //   }
          // },
          // style: {
          //   fill: "#82ccdd",
          //   stroke: "#82ccdd",
          //   lineWidth: 2
          // }
        },
        animation: {
          type: "clipingWithData"
        },
        seriesField: "type",
        responsive: true
      });
      linePlot.render();
    },
    initCanvasPie() {
      let height = this.$refs.canvasPie.clientHeight;
      let width = this.$refs.canvasPie.clientWidth;
      let data = this.typeList;
      const dv = new DataView().source(data);
      dv.transform({
        type: "map",
        callback(row) {
          row.value = Number(row.TotalCount1) + Number(row.TotalCount2); // 为每条记录新添加一个 z 字段
          return row;
        }
      });
      dv.transform({
        type: "filter",
        callback(row) {
          return row.value > 0;
        }
      });

      const piePlot = new Pie(document.getElementById("canvasPie"), {
        height: height,
        width: width,
        padding: 10,
        title: {
          visible: true,
          text: "职权类别统计",
          style: {
            fill: "#82ccdd"
          }
        },
        radius: 0.8,
        data: dv.rows,
        angleField: "value",
        colorField: "Name",
        label: {
          visible: true,
          type: "outer-center",
          style: {
            fill: "#82ccdd",
            lineWidth: 0,
            fontSize: 14,
            strokeOpacity: 0
          },
          formatter: (v, n) => {
            return n._origin.Name + ": " + v;
          }
        },
        legend: {
          visible: false
        }
      });

      piePlot.render();
    },
    initCanvasLiquid() {
      let height = this.$refs.canvasLiquid.clientHeight;
      let width = this.$refs.canvasLiquid.clientWidth;
      // registerShape("interval", "liquid-fill-gauge", {
      //   // 1. 定义关键点
      //   getPoints(cfg) {
      //     const x = cfg.x;
      //     const y = cfg.y;
      //     const y0 = cfg.y0;
      //     const width = cfg.size;
      //     return [
      //       { x: x, y: (y - y0) / 2 },
      //       { x: x - width / 2, y: y0 },
      //       { x: x, y: y },
      //       { x: x + width / 2, y: y0 }
      //     ];
      //   },

      //   // 2. 绘制
      //   draw(cfg, group) {
      //     const points = this.parsePoints(cfg.points); // 将0-1空间的坐标转换为画布坐标
      //     const polygon = group.addShape("circle", {
      //       attrs: {
      //         x: points[0].x,
      //         y: points[0].y,
      //         r: points[0].x / 2,
      //         stroke: "#ff0000",
      //         fillOpacity: 0,
      //         lineWidth: 10
      //         // ...cfg.defaultStyle
      //       }
      //     });
      //     console.info("???");
      //     console.info(polygon);
      //     return polygon;
      //   }
      // });
      // const data = [{ genre: "Sports", value: 50, able: 27500 }];
      // const chart = new Chart({
      //   container: "canvasLiquid",
      //   height: height,
      //   width: width
      // });
      // chart.data(data, {
      //   value: {
      //     min: 0,
      //     max: 100
      //   }
      // });
      // chart.legend(false);
      // chart.axis(false);
      // chart
      //   .interval()
      //   .position("genre*value")
      //   .shape("liquid-fill-gauge")
      //   .color("#ff0000");
      // data.forEach(row => {
      //   chart.annotation().text({
      //     // top: true,
      //     position: {
      //       gender: row.genre,
      //       value: 50
      //     },
      //     content: `${row.value}%`,
      //     style: {
      //       opacity: 0.75,
      //       fontSize: 30,
      //       textAlign: "center"
      //     }
      //   });
      // });

      // chart.render();
      let value = this.serviceCount.YearAcceptCount;
      let max = value * 2 > 10000 ? value * 2 : 10000;
      const liquidPlot = new Liquid(document.getElementById("canvasLiquid"), {
        height: height,
        width: width,
        padding: 1,
        min: 0,
        max: max,
        value: value,
        pixelRatio: 2,
        lineSize: 5,
        radius: 1,
        liquidStyle: {
          lineWidth: 5
        },
        statistic: {
          visible: true,
          style: {
            stroke: "#82ccdd",
            lineWidth: 1,
            fillOpacity: 0,
            fontSize: 14
          },
          formatter: value => "已受理\n" + value + "件"
        },
        color: "#ff6b6b"
      });
      liquidPlot.render();
    },
    initCanvasMeterGauge() {
      let height = this.$refs.canvasMeterGauge.clientHeight;
      let width = this.$refs.canvasMeterGauge.clientWidth;

      // registerShape("interval", "triangle", {
      //   // 1. 定义关键点
      //   getPoints(cfg) {
      //     const x = cfg.x;
      //     const y = cfg.y;
      //     const y0 = cfg.y0;
      //     const width = cfg.size;
      //     return [
      //       { x: x - width / 2, y: y0 },
      //       { x: x, y: y },
      //       { x: x + width / 2, y: y0 }
      //     ];
      //   },
      //   // 2. 绘制
      //   draw(cfg, group) {
      //     const points = this.parsePoints(cfg.points); // 将0-1空间的坐标转换为画布坐标
      //     const polygon = group.addShape("path", {
      //       attrs: {
      //         path: [
      //           ["M", points[0].x, points[0].y],
      //           ["L", points[1].x, points[1].y],
      //           ["L", points[2].x, points[2].y]
      //         ],
      //         ...cfg.defaultStyle
      //       }
      //     });
      //     return polygon;
      //   }
      // });
      // const data = [
      //   { genre: "Sports", sold: 27500 },
      //   { genre: "Strategy", sold: 11500 },
      //   { genre: "Action", sold: 6000 },
      //   { genre: "Shooter", sold: 3500 },
      //   { genre: "Other", sold: 1500 }
      // ];

      // const chart = new Chart({
      //   container: "canvasMeterGauge",
      //   height: height,
      //   width: width
      // });

      // chart.data(data);
      // chart
      //   .interval()
      //   .position("genre*sold")
      //   .shape("triangle")
      //   .color("genre");
      // chart.render();
      let value = this.serviceCount.YearFinishCount;
      let max = value * 2 > 10000 ? value * 2 : 10000;
      const liquidPlot = new Liquid(
        document.getElementById("canvasMeterGauge"),
        {
          height: height,
          width: width,
          padding: 1,
          min: 0,
          max: max,
          value: value,
          pixelRatio: 2,
          lineSize: 5,
          radius: 1,
          liquidStyle: {
            lineWidth: 5
          },
          statistic: {
            visible: true,
            style: {
              stroke: "#82ccdd",
              lineWidth: 1,
              fillOpacity: 0,
              fontSize: 14
            },
            formatter: value => "已办结\n" + value + "件"
          },
          color: "#1dd1a1"
        }
      );
      liquidPlot.render();
      // let height = this.$refs.canvasMeterGauge.clientHeight;
      // let width = this.$refs.canvasMeterGauge.clientWidth;
      // const gaugePlot = new MeterGauge(
      //   document.getElementById("canvasMeterGauge"),
      //   {
      //     height: height,
      //     width: width,
      //     value: 80,
      //     padding: 1,
      //     gaugeStyle: {
      //       tickLabelSize: 20
      //     },
      //     min: 0,
      //     max: 200,
      //     pixelRatio: 2
      //   }
      // );
      // gaugePlot.render();
    },
    initCanvasColumn() {
      let height = this.$refs.canvasColumn.clientHeight;
      let width = this.$refs.canvasColumn.clientWidth;
      let data = [];
      Object.keys(this.dayModel).forEach(key => {
        let name = "";
        switch (key) {
          case "FeeNormTotalCount":
            name = "收费职权";
            break;
          case "Day15Count":
            name = "15个工作日内办理";
            break;
          case "Day10Count":
            name = "10个工作日内办理";
            break;
          case "Day5Count":
            name = "5个工作日内办理";
            break;
          case "Day3Count":
            name = "3个工作日内办理";
            break;
          case "Day0Count":
            name = "即办";
            break;
          default:
            return;
        }
        data.push({
          type: name,
          value: this.dayModel[key]
        });
      });
      const columnPlot = new Column(document.getElementById("canvasColumn"), {
        height: height,
        width: width,
        forceFit: true,
        data,
        padding: "auto",
        xField: "type",
        yField: "value",
        colorField: "type",
        xAxis: {
          visible: true,
          grid: {
            visible: false
          },
          line: {
            visible: true,
            style: {
              stroke: "#82ccdd"
            }
          },
          tickLine: {
            visible: true,
            style: {
              stroke: "#82ccdd"
            }
          },
          label: {
            visible: true,
            style: {
              fill: "#82ccdd"
            }
          },
          title: {
            visible: false
          }
        },
        yAxis: {
          visible: true,
          grid: {
            visible: false
          },
          label: {
            visible: true,
            style: {
              fill: "#82ccdd"
            }
          },
          title: {
            visible: false
          }
        },
        legend: {
          visible: false
        },
        title: {
          visible: true,
          position: "left",
          text: "职权办理统计",
          style: {
            fontSize: 16,
            fill: "#82ccdd"
          }
        }
      });

      columnPlot.render();
    },
    initTable() {
      var tableNums = this.deptList;
      let len = this.deptList.length;
      if (len > 10) {
        this.deptList = this.deptList.concat(this.deptList);
        setInterval(() => {
          this.count--;
          // this.deptList.push(this.deptList[0]);
          // console.info(this.deptList.length);
          // if (this.count > len) {
          //   this.deptList.splice(0, len);
          //   this.count = 0;
          //   // this.deptList.push(this.deptList[0]);
          //   // this.deptList.splice(0, 1);
          // }

          // if (this.count % len == 0) {
          //   this.deptList = this.deptList.concat(this.deptList);
          // }
          if (this.count <= -30 * len) {
            this.count = 0;
          }
        }, 50);
      }

      // console.log("initTable -> tableNums", tableNums);
      // let a = document.getElementById("table_body").clientHeight;
      // console.info(a);
      // var MyMarhq = "";
      // clearInterval(MyMarhq);
      // $(".tbl_body tbody").empty();
      // $(".tbl_header tbody").empty();

      // $.each(tableNums, function(i, item) {
      //   var str =
      //     "<tr>" +
      //     '<td class="tdOne">' +
      //     item.Name +
      //     "</td>" +
      //     "<td>" +
      //     item.Value1 +
      //     "</td>" +
      //     "<td>" +
      //     item.Value2 +
      //     "</td>" +
      //     "<td>" +
      //     item.Value3 +
      //     "</td>" +
      //     "</tr>";
      //   $(".tbl_body tbody").append(str);
      //   $(".tbl_header tbody").append(str);
      // });

      // if (tableNums.length >= 2) {
      //   $(".tbl_body tbody").html(
      //     $(".tbl_body tbody").html() + $(".tbl_body tbody").html()
      //   );
      //   $(".tbl_body").css("top", "0");
      //   var tblTop = 0;
      //   var speedhq = 50; // 数值越大越慢
      //   var outerHeight = $(".tbl_body tbody")
      //     .find("tr")
      //     .outerHeight();
      //   function Marqueehq() {
      //     if (tblTop <= -outerHeight * tableNums.length) {
      //       tblTop = 0;
      //     } else {
      //       tblTop -= 1;
      //     }
      //     $(".tbl_body").css("top", tblTop + "px");
      //   }

      //   MyMarhq = setInterval(Marqueehq, speedhq);
      //   // 鼠标移上去取消事件
      //   $(".tbl_header tbody").hover(
      //     function() {
      //       clearInterval(MyMarhq);
      //     },
      //     function() {
      //       clearInterval(MyMarhq);
      //       MyMarhq = setInterval(Marqueehq, speedhq);
      //     }
      //   );
      // }
    },
    initData() {
      this.$axios({
        url: "api/getbigdata",
        method: "get",
        params: {
          areacode: "00"
        }
      }).then(res => {
        this.serviceCount = res.data.serviceCount;
        this.weekList = res.data.weekList;
        this.areaList = res.data.areaList;
        this.dayModel = res.data.dayModel;
        this.typeList = res.data.typeList;
        this.deptList = res.data.deptList.concat(res.data.deptList);
        this.deptList = this.deptList.concat(res.data.deptList);
        this.initCanvasLine();
        this.initCanvasPie();
        this.initCanvasLiquid();
        this.initCanvasMeterGauge();
        this.initCanvasColumn();
        this.initTable();
      });
    }
  },
  mounted() {
    this.initTime();
    this.initInterval();
    this.initMap();
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.contentbox {
  width: 100%;
  height: 100vh;
  min-height: 900px;
  // background-color: #d76b51;
  background-image: url("./../../assets/bd_bg.png");
  /* 标题栏 */
  .content-title {
    width: 100%;
    height: 60px;
    position: relative;

    .content-titlebox {
      width: auto;
      height: 60px;
      padding: 0 20px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      border-bottom: 1px solid rgba(189, 189, 189, 0.3);
      span {
        display: inline-block;
        font-size: 40px;
        font-weight: 700;
        color: #82ccdd;
        -webkit-animation-duration: 2s;
        -webkit-animation-fill-mode: both;
        animation-duration: 2s;
        animation-fill-mode: both;
      }
    }
  }
  .content-timebox {
    width: 200px;
    height: 60px;
    float: right;
    #content-time {
      height: 60px;
      color: #82ccdd;
      padding: 30px 0 0 0;
    }
  }
  .content-charts {
    width: 100%;
    height: calc(100% - 60px);
    padding: 10px;
    display: flex;
    position: relative;
    .content_charts_left {
      flex: 1;
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      .left_top_textList {
        flex: 1;
        width: 100%;
        // height: 100%;
        margin-bottom: 20px;
        // .textList_div {
        //   height: 40px;
        //   width: 100%;
        //   display: flex;
        //   align-items: flex-end;
        //   p {
        //     color: #f1f1f1;
        //     font-size: 18px;
        //     span {
        //       font-size: 30px;
        //       margin: 0 5px;
        //       display: inline-block;
        //       color: #e17055;
        //       font-weight: bold;
        //     }
        //   }
        // }
      }
      .left_mid_today {
        flex: 1;
        width: 100%;
        // height: 100%;
        margin-bottom: 20px;
      }
      .left_bottom_lineNum {
        flex: 1;
        width: 100%;
        // height: 100%;
      }
    }
    .content_charts_mid {
      flex: 2;
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      .mid_top_map {
        flex: 2;
        width: 100%;
        // height: 100%;
        margin-bottom: 20px;
        position: relative;
        #container {
          width: 100%;
          height: 100%;
        }
        .map_infos_add {
          position: absolute;
          top: 20px;
          left: 30px;
          right: 0;
          width: 100%;
          height: 60px;
          margin: auto;
          z-index: 99;
          p {
            width: 100%;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #82ccdd;
            text-align: left;
            font-weight: bold;
          }
        }
      }
      .mid_bottom_chart {
        flex: 1;
        width: 100%;
        // height: 100%;
      }
    }
    .content_charts_right {
      flex: 1;
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      flex-direction: column;
      .right_top_pie {
        flex: 1;
        width: 100%;
        // height: 100%;
        margin-bottom: 20px;
      }
      .right_bottom_list {
        flex: 1;
        width: 100%;
        // height: 100%;
      }
    }
    .charts_box {
      // border: 1px solid rgba(0, 206, 201, 0.3);
      box-shadow: 0px 0px 20px #81ecec inset;
      padding: 20px;
      // color: rgb(0, 206, 201);
    }
    .charts_title {
      width: 100%;
      height: 30px;
      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: left;
        color: #82ccdd;
        // border-bottom: 1px solid #b2bec3;
      }
    }
    .charts_data {
      width: 100%;
      height: 100%;
      // height: calc(100% - 30px);
      position: relative;
      display: flex;
      &.has_charts_title {
        height: calc(100% - 30px) !important;
      }
      .charts_table {
        flex: 1;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .charts_today_count {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          animation: littleJump;
          animation-duration: 2s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-direction: alternate;
          span {
            position: relative;
            z-index: 20;
            color: #f5f6fa;
          }
          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            // width: 100px;
            // height: 100px;
            width: 0;
            height: 0;
            border: 50px solid;

            transform: translateY(25%) rotate(-45deg);
            z-index: 10;
          }
        }
        .charts_today_count_left {
          animation-delay: 0s;
          &::after {
            border-color: #ff6b6b #ff6b6b transparent transparent;
          }
        }
        .charts_today_count_right {
          animation-delay: 1s;
          &::after {
            border-color: #1dd1a1 #1dd1a1 transparent transparent;
          }
        }
        .charts_canvas {
          width: 100%;
          height: 100%;
        }
        .tbl_header {
          width: 100%;
          position: absolute;
          top: 0px;
          left: 0;
          z-index: 20;
        }

        .tbl_hidden {
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;
          margin-top: 30px;
        }

        .tbl_hidden .tbl_body {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        table {
          color: #82ccdd;
          width: 100%;
          text-align: center;
          font-size: 15px;
          line-height: 30px;
        }

        table thead,
        table tbody .tdOne {
          color: #82ccdd;
        }
      }
    }
  }
}
.titel-enter-active {
  animation-name: leftRollIn;
}
.titel-leave-active {
  animation-name: rightRollOut;
}
@keyframes leftRollIn {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-1000%, 0, 0) rotate3d(0, 0, 1, -120deg);
    transform: translate3d(-1000%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes rightRollOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(1000%, 0, 0) rotate3d(0, 0, 1, 120deg);
    transform: translate3d(1000%, 0, 0) rotate3d(0, 0, 1, 120deg);
  }
}

@keyframes littleJump {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(20%);
  }
}
</style>